import React from "react";
import { Link } from "react-router-dom";
import ShowAwardsSidebarContainer from "../Awards/components/ShowAwardsSidebarContainer";
import SagIneligibleLabel from "./components/SagIneligibleLabel";
import { S3URL } from "../../../data/globalConstants";
import ShowMeta from "./components/ShowMeta";
import { useGuildPath } from "../../../utils/Guild/useGuild";

export default function ShowSidebar({
  showData,
  genreSlug,
  showSlug,
  showAwards,
  displayAwards,
}) {
  const guildPath = useGuildPath();

  return (
    <>
      <div className="show-left-column-meta">
        <div className="show-tt">
          <Link to={guildPath(`/${genreSlug}/${showSlug}/`)}>
            <img
              className={"show-tt-img"}
              src={S3URL + showData?.titleTreatment}
              alt={showData?.title}
            />
          </Link>
        </div>
        <ShowMeta showData={showData} />
      </div>
      {displayAwards && (
        <div className="d-none d-sm-block show-left-column-awards-sizer">
          <ShowAwardsSidebarContainer
            genreSlug={genreSlug}
            showSlug={showSlug}
            showAwards={showAwards}
          />
        </div>
      )}
      <SagIneligibleLabel show={showData?.sag_ineligible === 1} />
    </>
  );
}
